module.exports = __webpack_public_path__ + "images/CPR.8b01d084eeb80621284c5248c5767ce7.png";